
const SOCIAL_LINK = {
    GET: {
        REQUEST: 'SOCIAL_LINK.GET.REQUEST',
        FAILURE: 'SOCIAL_LINK.GET.FAILURE',
        SUCCESS: 'SOCIAL_LINK.GET.SUCCESS'
    }
}
export default SOCIAL_LINK;